import React from 'react';
import { Combobox } from '@oysterjs/ui/combobox';
import {
  PdfAttachmentSection,
  type PdfAttachmentSectionProps
} from './artifact-focus-html-document-render-pdf-attachment';

export type ProducerSignature = {
  id: string;
  producerName: string;
  agencyName: string;
  isDefault: boolean;
};

export const ProducerSignatureOptions = (props: {
  agencyProducerInformations: ProducerSignature[];
  userProducerInformations: ProducerSignature[];
  value: string | null;
  onChange: (value: string | null) => void;
  description?: string;
}) => {
  const options = [
    ...props.agencyProducerInformations.map((pi) => ({
      value: pi.id,
      label: pi.producerName || pi.agencyName || 'Agency signature',
      description: 'Agency',
      badgeText: pi.isDefault ? 'Default' : undefined
    })),
    ...props.userProducerInformations.map((pi) => ({
      value: pi.id,
      label: pi.producerName || pi.agencyName || 'My signature',
      description: 'Mine',
      badgeText: pi.isDefault ? 'Default' : undefined
    }))
  ];

  if (options.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-medium font-body mt-0">Signature</h3>
      <p className="text-xs text-neutral-500 dark:text-neutral-400">
        {props.description ?? 'Choose a signature to include when opening this document.'}
      </p>
      <div className="mt-2">
        <Combobox
          value={props.value ?? ''}
          placeholder="Select a signature…"
          minQueryLength={0}
          maxOptions={50}
          options={options}
          onChange={(value) => props.onChange(value === '' ? null : value)}
        />
      </div>
    </div>
  );
};

export const PdfAttachmentOptions = ({
  children,
  description = 'Prepend pages before or append pages after the generated document (this export only)',
  ...attachments
}: PdfAttachmentSectionProps & {
  children?: React.ReactNode;
  description?: string;
}) => (
  <div className="p-6 space-y-6">
    {children}
    <div>
      <h3 className="text-sm font-medium font-body mt-0">PDF attachments</h3>
      <p className="text-xs text-neutral-500 dark:text-neutral-400">{description}</p>
      <PdfAttachmentSection {...attachments} />
    </div>
  </div>
);
